import { Star } from "lucide-react";

export const Stars = ({ value, size = "h-4 w-4", testId }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        className={`${size} ${n <= Math.round(value) ? "fill-[#dfa557] text-[#dfa557]" : "fill-none text-border"}`}
      />
    ))}
  </span>
);

export const StarInput = ({ value, onChange, testId }) => (
  <div className="flex items-center gap-1" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        aria-label={`${n} star${n > 1 ? "s" : ""}`}
        data-testid={`${testId}-star-${n}`}
        onClick={() => onChange(n)}
        className="transition-transform hover:scale-110"
      >
        <Star className={`h-7 w-7 ${n <= value ? "fill-[#dfa557] text-[#dfa557]" : "fill-none text-border hover:text-[#dfa557]"}`} />
      </button>
    ))}
  </div>
);
